<template>
  <div class="animated fadeIn">
    <b-modal v-model="showModal" hide-footer :title="modalTitle">
      <div v-if="selectedItem">
        <b-row v-if="selectedItem.preview">
          <b-col >
            <img :src="selectedItem.preview" style="max-width: 100%"/>
          </b-col>
          <b-col>
            <b-button class="mt-3 bg-success" block @click="expressEdition(selectedItem.template, selectedItem.isCarousel)">Editar</b-button>
            <b-button class="mt-3 bg-warning" block @click="closeModal">Fechar</b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-input-group class="mb-">
              <b-form-textarea
                disabled
                style="height: 300px; width: 100%;"
                class="form-control"
                v-model="selectedItem.text"
              />
            </b-input-group>
          </b-col>
          <b-col>
            <b-button class="mt-3 bg-success" v-clipboard:copy="selectedItem.text" block>Copiar</b-button>
            <b-button class="mt-3 bg-warning" block @click="closeModal">Fechar</b-button>
          </b-col>
        </b-row>
        <br/>
        <br/>
      </div>
    </b-modal>
    <div v-if="challenge">
      <b-row class="mt-3">
        <b-col v-if="challenge.extra">
          <router-link :to="'/ebook/' + challenge.extra + '/cover'" @click="bannerAction()">
            <img v-if="isMobileScreen" style="width: 100%;" src="/img/mat-complementar-banner-cel.png?1"/>
            <img v-else-if="!isMobileScreen" style="width: 100%;" src="/img/mat-complementar-banner.png?1"/>
          </router-link>
        </b-col>
      </b-row>
      <b-card>
        <b-row class="mt-3">
          <b-col class="text-center" sm="4" v-for="(week) in challenge.weeks" :key="week.name">
            <div v-if="selectedWeek != week" style="cursor: pointer;">
              <img :src="week.img" @click="selectedWeek = week, selectedDay = undefined" style="max-width: 100%; cursor: pointer;"/>
            </div>
            <b-row v-else>
              <b-col sm="8" offset-sm="2" class="text-center" v-for="(day, index) in week.days" :key="index">
                <b-form-group>
                  <b-button @click="selectedDay = day" class="btn-block" v-show="!openingTicket" variant="primary">
                      <h1>Dia {{index+1}}
                        <img src="/img/challenge/arrow-right.png" style="margin-top: 13px;" v-if="selectedDay != day" class="pull-right"/>
                        <img src="/img/challenge/arrow-down.png" style="margin-top: 13px;" v-else class="pull-right"/>
                      </h1>
                  </b-button>
                  <b-row v-if="selectedDay == day">
                    <b-col sm="12" v-for="item in day.items" :key="item._id" style="margin-top: 5px;">
                      <b-button @click="selectChallengeItem(item)" class="btn-block" v-show="!openingTicket" variant="outline-primary">
                          <img :src="getImgFromItem(item)" class="pull-left"/><b-badge style="margin-left: 10px; margin-top: 5px;" class="pull-left" variant="light">{{item.time}}</b-badge>{{item.title}}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import service from "../service";

export default {
  name: 'Support',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      errorMessage: undefined,
      text: "",
      openingTicket: false,
      success: false,
      textSources: "",
      textSubtitle: "",
      days: [{}, {}, {}, {}, {}],
      challenge: undefined,
      selectedWeek: undefined,
      selectedDay: undefined,
      selectedItem: undefined,
      showModal: false,
      modalTitle: ""
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    },
    supportEmail() {
      return localStorage.supportEmail;
    },
    supportWhatsapp() {
      return localStorage.supportWhatsapp;
    }
  },
  methods: {
    selectChallengeItem(item) {
      if (item.type != "pdf") {
        this.selectedItem = item;
        this.showModal = true;
        this.modalTitle = item.title;
      } else {
        window.open(item.text, '_blank');
      }
    },
    closeModal: function() {
      this.modalTitle = "";
      this.selectedItem = undefined;
      this.showModal = false;
    },
    decodeText: function(text) {
      if (text) {
        let text = this.text.replace(new RegExp("\n \n", 'g'), "\n\n");
        text = text.split("Fonte:")[0];
        let urlEncoded = encodeURI(text);
        
        let urlEnocdedNew = urlEncoded.replace(new RegExp("%0A", 'g'), "%E2%81%A3%0A");
        
        let finalSubtitle =  decodeURI(urlEnocdedNew);
        
        return finalSubtitle;
      }
      return false;
    },
    getImgFromItem(item) {
      switch (item.type) {
        case 'story':
          return "/img/challenge/instagram-stories.png";
        break;
        case 'instagram_post':
          return "/img/challenge/instagram-feed.png";
        break;
        case 'whatsapp_post':
          return "/img/challenge/whatsapp.png";
        break;
        case 'text':
          return "/img/challenge/whatsapp.png";
        break;
        case 'pdf':
          return "/img/challenge/pdf.png";
        break;
      }
      
      return "";
    },
    expressEdition(templateId, isCarousel) {
      if (this.isMobileScreen) {
        if (isCarousel) {
          this.$router.push({ name: 'Preview Carousel', params: { id: templateId, challenge: this.$route.params.id}});
        } else {
          this.$router.push({ name: 'Preview Design', params: { id: templateId, challenge: this.$route.params.id }});
        }
      } else {
        if (isCarousel) {
          window.open("/design/preview-carousel/" + templateId + "?challenge=" + this.$route.params.id, "_blank")
        } else {
          window.open("/design/preview/" + templateId + "?challenge=" + this.$route.params.id, "_blank")
        }
      }
    }
  },
  components: { Spinner },
  created() {
    service.getMe().then(me => {
      if (!me.challengeAccess && !me.admin && me.subscription.planType != 'FREEPASS') {
        this.$router.push({ name: 'ChallengeList'});
      }
    });

    service.getFullChallenge(this.$route.params.id).then(result => {
      this.challenge = result.challenge;
    });
  }
}
</script>

<style scoped>
.pc-img {
  max-width: 100%;
}

.mobile-img {
  width: 70%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
